<template>
  <WidgetWrapper class="widget-wrapper" :title="$t('ipTracker.title')">
    <ul class="list">
      <transition-group name="list">
        <li v-for="attack in top5Attackers" :key="attack.geocountry" class="attack">
          <CountryFlag :country="attack.geocountry" :size="open ? 'normal' : 'normal'" class="flag" />
          <div class="ip">
            {{ open ? `${attack.geocountry} (` : '' }}
            <AnimatedNumber class="count" :value="attack.sum" :duration="700" :round="1" easing="easeInOutExpo" />
            {{ open ? `)` : '' }}
          </div>
        </li>
      </transition-group>
    </ul>
  </WidgetWrapper>
</template>

<script>
import { mapGetters } from 'vuex';

import CountryFlag from 'vue-country-flag';
import WidgetWrapper from '../WidgetWrapper';

import AnimatedNumber from 'animated-number-vue';

export default {
  name: 'CountryTracker',
  props: {
    open: { type: Boolean, default: true }
  },
  components: { CountryFlag, WidgetWrapper, AnimatedNumber },
  data: () => {
    return { countryList: [], listLen: 5 };
  },
  computed: {
    ...mapGetters({
      top5Attackers: 'eventStore/top5Attackers'
    })
  }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';
.widget-wrapper {
  padding-left: 0;
}
.list {
  // height: 200px;
  overflow: hidden;
  @media (min-width: $tablet) {
    // height: 250px;
  }
  padding-left: 0;
}
.attack {
  display: flex;
  align-items: center;
  // transition: all 0.7s ease-in-out;
  margin: 0;
  .flag {
  }
  .ip {
    margin: 0;
    white-space: nowrap;
  }
  .count {
    flex: 1;
    justify-self: flex-end;
  }

  @media (min-width: $phone) and (max-width: $tablet) {
    margin: 0 0 0em 0;
  }

  @media (min-width: $tablet) and (max-width: $desktop) {
    // margin: 0 0 0.7em 2em;
    font-size: 1.2em;
  }

  @media (min-width: $desktop) {
    // margin: 0 0 0.7em 0;
    font-size: 1.2em;
  }
}

.list-enter-active {
  transition: transform 0.7s ease;
}
.list-leave-active {
  transition: transform 0.7s cubic-bezier(1, 0.5, 0.8, 1);
}
.list-enter, .list-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.list-leave-to {
  position: absolute;
  transform: translateY(-10px);
  opacity: 0;
}
// .list-move {
//   transition: transform 1s;
// }
</style>
